import { login, logout, getInfo } from '@/api/auth'
import { getToken, setToken, removeToken } from '@/utils/auth'

const state = {
  token: getToken(),
  userInfo: {},
  roles: [],
  permissions: [],
  menus: [],
  moduleEnables: {}
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
  },
  SET_USER_INFO(state, info) {
    state.userInfo = info
  },
  SET_ROLES(state, roles) {
    state.roles = roles
  },
  SET_PERMISSIONS(state, permissions) {
    state.permissions = permissions
  },
  SET_MENUS(state, menus) {
    state.menus = menus
  },
  SET_MODULE_ENABLES(state, enables) {
    state.moduleEnables = enables || {}
  }
}

const actions = {
  login({ commit }, userInfo) {
    const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), password })
        .then(res => {
          const { token, userInfo } = res.data
          commit('SET_TOKEN', token)
          commit('SET_USER_INFO', userInfo)
          setToken(token)
          resolve()
        })
        .catch(reject)
    })
  },

  getInfo({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      getInfo()
        .then(res => {
          const data = res.data
          commit('SET_USER_INFO', {
            id: data.id,
            username: data.username,
            nickname: data.nickname,
            avatar: data.avatar,
            email: data.email
          })
          commit('SET_ROLES', data.roles || [])
          commit('SET_PERMISSIONS', data.permissions || [])
          commit('SET_MENUS', data.menus || [])
          if (data.site_name !== undefined || data.copyright !== undefined) {
            dispatch('settings/setSiteInfo', {
              site_name: data.site_name,
              copyright: data.copyright
            }, { root: true })
          }
          commit('SET_MODULE_ENABLES', data.module_enables || {})
          resolve(data)
        })
        .catch(reject)
    })
  },

  logout({ commit }) {
    return new Promise((resolve, reject) => {
      logout()
        .then(() => {
          commit('SET_TOKEN', '')
          commit('SET_USER_INFO', {})
          commit('SET_ROLES', [])
          commit('SET_PERMISSIONS', [])
          commit('SET_MENUS', [])
          commit('SET_MODULE_ENABLES', {})
          removeToken()
          resolve()
        })
        .catch(error => {
          commit('SET_TOKEN', '')
          removeToken()
          reject(error)
        })
    })
  },

  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_USER_INFO', {})
      commit('SET_ROLES', [])
      commit('SET_PERMISSIONS', [])
      commit('SET_MENUS', [])
      commit('SET_MODULE_ENABLES', {})
      removeToken()
      resolve()
    })
  }
}

export default { namespaced: true, state, mutations, actions }
